module.exports = __webpack_public_path__ + "static/media/prayingman.c89b0100.png";